export const GENERATE_INVOICE = 'GENERATE_INVOICE';
export const INITIATE_PAYMENT = 'INITIATE_PAYMENT';
export const RECOMMEND_PAYMENT = 'RECOMMEND_PAYMENT';
export const APPROVE_PAYMENT = 'APPROVE_PAYMENT';
export const APPROVE_PATIENT_REFERRAL = 'APPROVE_PATIENT_REFERRAL';
export const SCHEDULE_REFERRAL_APPOINTMENT = 'SCHEDULE_REFERRAL_APPOINTMENT';
export const DFA_APPROVAL = 'DFA_APPROVAL';
export const PERMSEC_APPROVAL = 'PERMSEC_APPROVAL';
export const CREATE_PATIENT_REFERRAL = 'CREATE_PATIENT_REFERRAL';